import React, { useEffect, useState } from 'react';
import axios from 'axios';

function App() {
  const [imageUrl, setImageUrl] = useState('');
  
  useEffect(() => {
    setImageUrl('https://coba.kerissumenep.com/images/sample.jpg');
  }, []);

  return (
    <div style={{ textAlign: 'center' }}>
      <h1>Random Image from Unsplash</h1>
      {imageUrl ? <img src={imageUrl} alt="Random from API" style={{ maxWidth: '100%' }} /> : <p>Loading...</p>}
    </div>
  );
}

export default App;